<button id="runsubmitpopup" style="display:none;" data-bs-toggle="modal" data-bs-target="#run_submit_newpopup"></button>
<div class="modal " id="run_submit_newpopup" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content modal-content-50">
      <div class="modal-main-content">
        <h2 class="modal-heading center" tabindex="0">Submit Final Plan</h2>
        <p class="modal-heading center" tabindex="0">Are you sure you want to submit your Action Plan?</p>
        <p class="modal-heading center" tabindex="0">Note: You may not edit your action plan for this quarter after clicking Submit.
        </p>
        <br>
        <div class="button-container button-container-center">
          <button class="modal-button delete-close" type="button" data-bs-dismiss="modal">Cancel</button>
          <button class="modal-button yes-button" type="button" (click)="submitForm()"
            data-bs-dismiss="modal">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>